export default {
  tasks: [],
  tasksFilter: [],
  currentTask: {},
  filters: {},
  paginationOptions: {}
};
